import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    {
        key: 'SET_SKU',
        label: 'setSku',
        defaultShow: true,
    },
    {
        key: 'MASTER_PRODUCT_NAME',
        label: 'setName',
        defaultShow: true,
    },
    {
        key: 'SKU_COUNTS',
        label: 'skuCount',
        type: 'number-filter',
        defaultShow: true,
    },
    {
        key: 'PRODUCTS_COUNTS',
        label: 'productsCount',
        type: 'number-filter',
        defaultShow: true,
    },
];
